import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { ALLOWED_MODULES } from "../../constants/enums";
import { REACT_APP_NAV_ROUTES } from "../../router/AppNavigation";

const GeneralLeads = Loadable(
  lazy(() =>
    import("./GeneralLeads").then(({ GeneralLeads }) => ({
      default: GeneralLeads,
    })),
  ),
);

export const generalLeadRoutes = [
  {
    path: REACT_APP_NAV_ROUTES.leads.generalLeads,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.GENERAL_LEADS]}>
        <GeneralLeads />
      </AuthorizedRoute>
    ),
  },
];
